<template>
    <div class="layer themeColor">
            <div style="width: 75%;" class="card">
                <h2> إعادة الضبط </h2>
                <br>
                <!-- <p>
                        تم تصميم هذا الموقع البيسط لمساعدة المسلمين لمعرفة أوقات الصلوات في جميع انحاء العالمو كما يوجد به بعض من الأحاديث الصحيحة و أذكار الصباح و المساءو كما يوجد به مصحف مرئي
                        <br>
                        ارجوا ان هذه الموقع أن ينال إعجابكم ;)
                    </p> -->
                <p>
                    سيتم إعادة ضبط المنطقة الزمنية
                </p>
                <br>
                <section class="contiue">
                    <!-- <router-link to="/home/timezone" tag="button">متابعة</router-link> -->
                    <button title="إلغاء" style="background: #00000010; color: #555;" @click="closeTheWindowReset">إالغاء</button>
                    <button title="إعادة ضبط المنطقة الزمنية" @click="resetter">متابعة</button>
                </section>
            </div>
        </div>
</template>

<script>
export default {
    methods: {
        closeTheWindowReset() {
            this.$emit("closeReset", false);
        },
        resetter() {
            window.localStorage.removeItem("timeZone");
            // alert("ok");
           open(`${location.protocol}//${location.host}/`, "_self");

        }
    }
} 
</script>

<style scoped>

.card div, p {text-align: center;}
p {margin: 15px 0;}



</style>